export default "__VITE_ASSET__ed63581b__"